/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const CloseCircle = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 31 31" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M15.5 0A15.5 15.5 0 1 0 31 15.5 15.5 15.5 0 0 0 15.5 0zm6.28 20.7a.76.76 0 0 1 0 1.08.75.75 0 0 1-.54.22.76.76 0 0 1-.54-.22l-5.2-5.2-5.2 5.2a.77.77 0 0 1-1.08 0 .76.76 0 0 1 0-1.08l5.19-5.2-5.19-5.2a.76.76 0 0 1 1.08-1.08l5.2 5.2 5.2-5.2a.76.76 0 1 1 1.08 1.08l-5.2 5.2z" />
      </g>
    </svg>
  </span>
);

CloseCircle.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

CloseCircle.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default CloseCircle;
